import { render, staticRenderFns } from "./flowUseRecord.vue?vue&type=template&id=e74ffe18"
import script from "./flowUseRecord.vue?vue&type=script&lang=js"
export * from "./flowUseRecord.vue?vue&type=script&lang=js"
import style0 from "./flowUseRecord.vue?vue&type=style&index=0&id=e74ffe18&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports